import { render, staticRenderFns } from "./VinTableManager.vue?vue&type=template&id=3e93db56&scoped=true"
import script from "./VinTableManager.vue?vue&type=script&lang=js"
export * from "./VinTableManager.vue?vue&type=script&lang=js"
import style0 from "./VinTableManager.vue?vue&type=style&index=0&id=3e93db56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e93db56",
  null
  
)

export default component.exports